import { render, staticRenderFns } from "./PrestationInvoiceReport.vue?vue&type=template&id=0f27e654&scoped=true"
import script from "./PrestationInvoiceReport.vue?vue&type=script&lang=js"
export * from "./PrestationInvoiceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27e654",
  null
  
)

export default component.exports